import { useEffect, useState } from 'react'
import { CustomRadio } from '../../../../ui/molecules/radioButton'
import { SelectCustom } from '../../../../ui/molecules/select'
import { TableSelect } from '../../../../ui/molecules/tableSelect'
import { InfoBox } from '../../../../ui/molecules/infoBox'
import { Calendar } from '../../../../ui/molecules/calendar'
import { ProtocolSelectByObject } from '../../../../ui/molecules/ProtocolSelectByObj'
import { useAppDispatch, useAppSelector } from '../../../../lib/redux/hooks'
import { format } from "date-fns";
import { MeasureVersionOptions } from '../../../../utils/measuresUtils'
import { setCreateDateM018 } from '../slice'


export function AddNewM018FormsStep1() {
    const dispatch = useAppDispatch()
    const sessionState = useAppSelector(state => state.session)
    const m018State = useAppSelector(state => state.m018)

    return (
        <div>
            <div className="formFieldset-container">
                <div className='formFieldset-header'>
                    <div className='text-left'>
                        <span className='rid-title' style={{ color: '#fff' }}>M018 </span>
                        <span className='rid-title' style={{ color: '#74A4A9' }}>/</span>
                        <span className='rid-title' style={{ color: '#d9e6e8' }}>Inserisci Data</span>
                    </div>
                </div>
                <div style={{ display: 'flex', gap: '16px', padding: '24px' }}>
                    <div style={{ flex: '0 0 33.33%' }}>
                        <div className="text-left">
                            <span className="input-label">Data M018</span>
                        </div>
                        <Calendar
                            selected={m018State.createNewM018.m018Date}
                            onChange={(date) => dispatch(setCreateDateM018(date)) }
                        />
                    </div>

                    {/* altri componenti affiancati se servono */}
                </div>
            </div>
        </div>
    )
}